import $ from "jquery";
import { forms } from "../framework/forms";

function init() {
    $(document).on("click", ".rolecardprint", printCard);
}

function printCard() {
    const url = $(this).attr("printurl");
    forms.openPrintWindow(url);
}

export const instructorPortal = {
    init: init
};